var map = {
	"./01_Keith_Salins@Entrepreneur.jpg": 645,
	"./02_Sindhu_John@Children's_Author.jpg": 925,
	"./03_Aathira_Sethumadhavan@Nutritionist.jpg": 835,
	"./04_P_G_Diwakar@ISRO_Chair_Professor.jpg": 19,
	"./05_Satish_B_S@Director_Aryabhatta_Planetarium.jpg": 38,
	"./06_Manjamma_Jogathii@Trans_Folk_Artist.jpg": 128,
	"./07_Sitavva_Joddati@Social_Activist.jpg": 623
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 417;